import React from 'react';

const AcademicPage_4_AAMAS = () => {
  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh', fontFamily: 'Georgia, serif' }}>
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* 标题 */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '36px', 
            fontWeight: 'normal', 
            color: '#333', 
            lineHeight: '1.2',
            marginBottom: '20px'
          }}>
            Large Language Model Assisted Multi-Agent Dialogue for Ontology Alignment
          </h1>
          
          {/* 作者列表 */}
          <div style={{ fontSize: '16px', color: '#666', lineHeight: '1.5' }}>
            Shiyao Zhang, Yuji Dong, <span style={{ color: '#4A90E2', fontWeight: 'bold' }}>Yichuan Zhang</span>, Terry R Payne, Jie Zhang
          </div>
        </div>

        {/* 摘要部分 */}
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            fontSize: '24px', 
            fontWeight: 'normal', 
            color: '#333', 
            textAlign: 'center',
            marginBottom: '30px',
            fontStyle: 'italic'
          }}>
            Abstract
          </h2>
          
          <div style={{ 
            fontSize: '16px', 
            color: '#444', 
            lineHeight: '1.6', 
            textAlign: 'justify'
          }}>
            <p style={{ marginBottom: '20px' }}>
            Ontology alignment is a critical challenge in semantic web and knowledge management, requiring the identification 
            of semantic correspondences between different ontologies. Traditional approaches often rely on lexical and 
            structural similarity measures, which may not capture the nuanced semantic relationships that exist between 
            concepts. This paper presents a novel approach that leverages large language models (LLMs) to facilitate 
            multi-agent dialogue for ontology alignment. Our framework employs multiple specialized agents that engage in 
            structured conversations to identify and validate potential alignments between ontology concepts. The LLM serves 
            as a mediator and reasoning engine, helping agents understand context, resolve ambiguities, and reach consensus 
            on alignment decisions. We evaluate our approach on standard ontology alignment benchmarks and demonstrate 
            significant improvements in alignment accuracy compared to traditional methods. Our results show that the 
            multi-agent dialogue approach, enhanced by LLM capabilities, can effectively capture complex semantic relationships 
            and produce more accurate ontology alignments, particularly in domains with specialized terminology and 
            conceptual structures.
            </p>
          
          </div>
        </div>

        {/* 按钮部分 */}
        <div style={{ marginBottom: '40px' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '20px',
            flexWrap: 'wrap'
          }}>
                         <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Code
             </button>
             
             <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Website
             </button>
             
             <button style={{
               padding: '10px 20px',
               fontSize: '14px',
               fontWeight: 'normal',
               color: '#000',
               backgroundColor: '#fff',
               border: '1px solid #000',
               borderRadius: '4px',
               cursor: 'pointer',
               transition: 'all 0.2s ease',
               minWidth: '100px',
               fontFamily: 'Arial, sans-serif'
             }}
             onMouseOver={(e) => {
               e.target.style.backgroundColor = '#f5f5f5';
             }}
             onMouseOut={(e) => {
               e.target.style.backgroundColor = '#fff';
             }}>
               Paper
             </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AcademicPage_4_AAMAS;
